/* Cart quantity stepper.
 * The +/- buttons talk to the Cart AJAX API and re-render the cart section
 * from the server, so Liquid stays the single source of truth for every
 * price instead of the page showing a stale total until a manual refresh. */
(function () {
  "use strict";

  var debounce;

  function root() {
    return document.querySelector("[data-cart-root]");
  }

  function busy() {
    var r = root();
    return !!r && r.classList.contains("is-updating");
  }

  function setBusy(on) {
    var r = root();
    if (!r) return;
    if (on) r.classList.add("is-updating");
    else r.classList.remove("is-updating");
  }

  function updateCount(count) {
    var els = document.querySelectorAll("[data-cart-count]");
    for (var i = 0; i < els.length; i++) {
      els[i].textContent = count;
      els[i].style.display = count > 0 ? "" : "none";
    }
  }

  function rerender(sections, sectionId) {
    var html = sections && sections[sectionId];
    if (!html) return false;
    var incoming = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("shopify-section-" + sectionId);
    var current = document.getElementById("shopify-section-" + sectionId);
    if (!incoming || !current) return false;
    current.innerHTML = incoming.innerHTML;
    return true;
  }

  function change(line, quantity) {
    var r = root();
    if (!r || busy()) return;
    var sectionId = r.getAttribute("data-section-id");
    var url = r.getAttribute("data-change-url") || "/cart/change.js";

    setBusy(true);
    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({
        line: line,
        quantity: quantity,
        sections: sectionId,
        sections_url: window.location.pathname
      })
    })
      .then(function (res) {
        if (!res.ok) throw new Error("cart change failed: " + res.status);
        return res.json();
      })
      .then(function (cart) {
        updateCount(cart.item_count);
        if (!rerender(cart.sections, sectionId)) {
          window.location.reload();
          return;
        }
        setBusy(false);
        document.dispatchEvent(new CustomEvent("cart:updated", { detail: cart }));
      })
      .catch(function () {
        window.location.reload();
      });
  }

  function lineOf(el) {
    var row = el.closest("[data-cart-line]");
    if (!row) return null;
    var line = parseInt(row.getAttribute("data-cart-line"), 10);
    return isNaN(line) ? null : { line: line, input: row.querySelector("[data-qty-input]") };
  }

  document.addEventListener("click", function (e) {
    if (!e.target || !e.target.closest) return;
    var btn = e.target.closest("[data-qty-change]");
    if (!btn) return;
    if (!btn.closest("[data-cart-line]")) return;
    e.preventDefault();
    if (busy()) return;

    var ctx = lineOf(btn);
    if (!ctx || !ctx.input) return;

    var delta = parseInt(btn.getAttribute("data-qty-change"), 10) || 0;
    var current = parseInt(ctx.input.value, 10);
    if (isNaN(current) || current < 0) current = 0;

    var next = Math.max(0, current + delta);
    ctx.input.value = next;
    change(ctx.line, next);
  });

  document.addEventListener("input", function (e) {
    if (!e.target || !e.target.closest) return;
    var input = e.target.closest("[data-qty-input]");
    if (!input || !input.closest("[data-cart-line]")) return;
    var ctx = lineOf(input);
    if (!ctx) return;

    clearTimeout(debounce);
    debounce = setTimeout(function () {
      var q = parseInt(input.value, 10);
      if (isNaN(q) || q < 0) q = 0;
      change(ctx.line, q);
    }, 600);
  });

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Enter" || !e.target || !e.target.closest) return;
    var input = e.target.closest("[data-qty-input]");
    if (!input || !input.closest("[data-cart-line]")) return;
    e.preventDefault();
    clearTimeout(debounce);
    var ctx = lineOf(input);
    if (!ctx) return;
    var q = parseInt(input.value, 10);
    if (isNaN(q) || q < 0) q = 0;
    change(ctx.line, q);
  });
})();
